// extracted by mini-css-extract-plugin
export default {"searchDropDown":"iXZvJ","container":"JNvc9 ZdH1P","searchContent":"CvJ1d","searchHistory":"kDykP"};